<template>
  <div>
    <Table
      :columns="columns"
      :data="getOrderedProducts"
      :is-accessible="true"
      @view="redirectToProductPage"
      :is-selectable="true"
      @newSelectedRows="$emit('newSelectedRows', $event)"
    >
      <template #title="{ row }">
        <div class="flex space-x-2">
          <span>{{ row.title }}</span>
          <VTooltip v-if="!isProductApproved(row)" theme="info-tooltip">
            <InformationCircleIcon class="cursor-pointer h-5 w-4 text-gray-400" aria-hidden="true" />

            <template #popper>
              <slot name="tooltip">
                <span>Le produit doit être validé par Estaly pour pouvoir proposer une offre d'assurance dessus</span>
              </slot>
            </template>
          </VTooltip>
        </div>
      </template>

      <template #status="{ row }">
        <FieldSpan :style-to-add="getStatusFieldDisplayStyle(row.status)" :value="row.status" />
      </template>

      <template #enabled="{ row }">
        <FieldSpan :style-to-add="getEnabledFieldDisplayStyle(row.enabled)" :value="row.enabled ? 'Oui' : 'Non'" />
      </template>
    </Table>
  </div>
</template>

<script>
import FieldSpan from "@/components/utils/FieldSpan.vue";
import { Table } from "@estaly/ui";
import { InformationCircleIcon } from "@heroicons/vue/outline";

export default {
  components: {
    InformationCircleIcon,
    Table,
    FieldSpan,
  },
  props: ["products"],

  computed: {
    columns() {
      return [
        {
          label: "Produit",
          field: "title",
          slot: "title",
        },
        {
          label: "Statut",
          field: "contractStatus",
          slot: "status",
        },
        {
          label: "Offre d'assurance déployée",
          field: "enabled",
          slot: "enabled",
        },
        {
          label: "Catégorie",
          field: "productType",
        },
      ];
    },

    getOrderedProducts() {
      return [...this.products].sort((a, b) => (a.enabled < b.enabled ? 1 : -1));
    },
  },
  methods: {
    getEnabledFieldDisplayStyle(isEnabled) {
      return isEnabled ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    },
    getStatusFieldDisplayStyle(status) {
      let result;
      switch (status) {
        case "Pending":
          result = "bg-yellow-100 text-yellow-800";
          break;
        case "Live":
          result = "bg-green-100 text-green-800";
          break;
        case "Matched":
          result = "bg-blue-100 text-blue-800";
          break;
        case "Refused":
          result = "bg-red-100 text-red-800";
          break;
        default:
          result = "bg-blue-100 text-blue-800";
      }
      return result;
    },
    isProductApproved(product) {
      return product.status === "Matched";
    },
    redirectToProductPage(product) {
      this.$router.push(`/platform/products/${product.id}`);
    },
  },
};
</script>
